import {
  ColumnPopoverDisplay,
  ExpandSearch,
  ListActionButton,
} from "components/common";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  allColumnsResidential,
  dataListPatientResidentialFields,
} from "./config";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  Popover,
  Row,
  Select,
  Space,
  Table,
  Typography,
} from "antd";
import {
  CalendarSVG,
  CalendarSelectedSVG,
  ExcelSVG,
  ListIconSVG,
  RefreshIconSVG,
} from "assets";
import dayjs from "dayjs";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setActiveKey, setButtonsHeader } from "redux/reducer/common";
import { residentialNurse } from "types/enums/residential-nurse";
import { setIdDDNT, setIdPhieuKham } from "redux/reducer/residentialNurse";
import { setIdPhieuKham as setIDPK } from "redux/reducer/common";

import Icons from "assets/icons";
import { inpatientService } from "api";
import { gioiTinhOptions } from "assets/constants/select-catagory-options";
import "./Listpatient.scss";
import {
  formatDateToString,
  getTableOptions,
  saveTableOptions,
  validatePhoneNumberLength,
} from "helper/common";
import { setLoading } from "redux/reducer/medicineStore";
import Notification from "components/common/notification/notification";
import { compareDate, parseDatetime, toDateTime } from "helper/format-date";
import { FORMAT_TIME, tabKeys } from "types/enums";
import CustomResizableTable from "components/common/CustomResizableTable/CustomResizableTable";
import { ColumnProps } from "types/models";

const initialValues = {
  ngayTaoTu: dayjs(),
  ngayTaoDen: dayjs(),
};

const ListPatient = () => {
  //redux
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector((state) => state.common.activeTab);
  //ref
  const [form] = Form.useForm();
  //state
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(50);
  const [loading, setLoading] = useState<boolean>(false);
  const [expand, setExpand] = useState<boolean>(false);
  const toogleExpand = () => {
    setExpand(!expand);
  };

  // const [allColumns, setShowColumns] = useState(allColumnsResidential);
  // const ngayTaoTu = Form.useWatch("ngayTaoTu", form);
  // const ngayTaoDen = Form.useWatch("ngayTaoDen", form);
  const [danhMucNoiTru, setDanhMucNoiTru] = useState<any>([]);
  const [trangThaiNoiTru, setTrangThaiNoiTru] = useState<any>([]);
  // const [today, setToday] = useState<boolean>(true);
  // const [yesterday, setYesterday] = useState<boolean>(false);
  const [selectedBtn, setSelectedBtn] = useState<number | null>(1);
  const [params, setParams] = useState<any>({
    ngayTaoTu: dayjs(),
    ngayTaoDen: dayjs(),
  });
  const searchTrangThai = Form.useWatch("idTrangThaiNoiTru", form);
  const expandRef = useRef<any>();

  // const clearFields = () => {
  //   setToday(true);
  //   setYesterday(false);
  //   form.resetFields();
  //   let data = {
  //     ngayTaoTu: initialValues.ngayTaoTu.format("DD/MM/YYYY"),
  //     ngayTaoDen: initialValues.ngayTaoDen.format("DD/MM/YYYY"),
  //   };
  //   setSearchValues(data);
  //   fetchInpatient(page, limit, data);
  // };

  let savedTableOption = getTableOptions(
    "NURSING_TABLE",
    localStorage.getItem("username")
  );
  const defaultColumns = savedTableOption
    ? allColumnsResidential.map((cl) => {
        if (savedTableOption.some((it) => it.dataIndex === cl.dataIndex)) {
          let tmp = savedTableOption.find(
            (it) => it.dataIndex === cl.dataIndex
          );
          return {
            ...cl,
            show: true,
            width: tmp?.width ?? null,
          };
        } else
          return {
            ...cl,
            show: false,
          };
      })
    : allColumnsResidential;

  const [columns, setColumns] = useState<ColumnProps[]>(
    defaultColumns.filter((e) => e.show == true)
  );

  const setShowAllColumns = (showColumns) => {
    saveTableOptions(
      "NURSING_TABLE",
      localStorage.getItem("username"),
      showColumns
    );
    setColumns(showColumns);
  };

  const handleDelete = async (record) => {
    try {
      let response = await inpatientService.delInpatient({
        id: record.id,
      });
      fetchInpatient();
    } catch (err) {}
  };
  const [inpatients, setInpatients] = useState<any>([]);
  const [searchValues, setSearchValues] = useState<any>({
    ngayTaoTu: initialValues.ngayTaoTu.format("DD/MM/YYYY"),
    ngayTaoDen: initialValues.ngayTaoDen.format("DD/MM/YYYY"),
  });

  // useMemo(() => {
  //   if (expand) {
  //     if (
  //       compareDate(ngayTaoTu, ngayTaoDen, "DD/MM/YYYY") &&
  //       compareDate(ngayTaoTu, dayjs(), "DD/MM/YYYY") &&
  //       !isNaN(ngayTaoTu)
  //     )
  //       setToday(true);
  //     else setToday(false);
  //   }
  // }, [ngayTaoTu, ngayTaoDen]);
  // useMemo(() => {
  //   if (expand) {
  //     if (
  //       compareDate(ngayTaoTu, ngayTaoDen, "DD/MM/YYYY") &&
  //       compareDate(ngayTaoTu, dayjs().subtract(1, "day"), "DD/MM/YYYY") &&
  //       !isNaN(ngayTaoTu)
  //     )
  //       setYesterday(true);
  //     else setYesterday(false);
  //   }
  // }, [ngayTaoTu, ngayTaoDen]);

  // const today = useMemo(() => {
  //   if (
  //     compareDate(ngayTaoTu, ngayTaoDen, "DD/MM/YYYY") &&
  //     compareDate(ngayTaoTu, dayjs(), "DD/MM/YYYY") &&
  //     !isNaN(ngayTaoTu)
  //   )
  //     return true;
  //   else return false;
  // }, [ngayTaoTu, ngayTaoDen]);

  // const yesterday = useMemo(() => {
  //   if (
  //     compareDate(ngayTaoTu, ngayTaoDen, "DD/MM/YYYY") &&
  //     compareDate(ngayTaoTu, dayjs().subtract(1, "day"), "DD/MM/YYYY") &&
  //     !isNaN(ngayTaoTu)
  //   )
  //     return true;
  //   else return false;
  // }, [ngayTaoTu, ngayTaoDen]);

  // fetch
  const fetchInpatient = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getListInpatient(
        page,
        limit,
        formatParams()
      );
      setInpatients(response);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // Notification("error", "Lỗi xảy ra khi lấy danh sách bệnh nhân");
    }
  };
  const fetchDanhMucNoiTru = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getTinhTrangNoiTru();
      setDanhMucNoiTru(response.data);
      setLoading(false);
    } catch (err) {}
  };
  const fetchDanhMucTrangThaiNoiTru = async () => {
    try {
      setLoading(true);
      let response = await inpatientService.getTinhTrangNoiTru();
      dataListPatientResidentialFields.find(
        (el) => el.name === "trangThai"
      ).options = response.data.map((el) => ({
        label: el.giaTri,
        value: el.id,
      }));
      setTrangThaiNoiTru(response.data);
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  //
  // const handleToday = async () => {
  //   setToday(true);
  //   setYesterday(false);
  //   form.setFieldValue("ngayTaoTu", dayjs());
  //   form.setFieldValue("ngayTaoDen", dayjs());

  //   let data = {
  //     ...searchValues,
  //     ngayTaoTu: dayjs().format("DD/MM/YYYY"),
  //     ngayTaoDen: dayjs().format("DD/MM/YYYY"),
  //   };
  //   setSearchValues(data);
  //   fetchInpatient(page, limit, data);
  // };
  // const onPaginationChange = (pg: number, pageSize?: number) => {
  //   setPage(pg);
  //   setLimit(pageSize);
  //   fetchInpatient(pg, pageSize, searchValues);
  // };
  // const handleYesterday = async () => {
  //   setToday(false);
  //   setYesterday(true);
  //   form.setFieldValue("ngayTaoTu", dayjs().subtract(1, "day"));
  //   form.setFieldValue("ngayTaoDen", dayjs().subtract(1, "day"));
  //   let data = {
  //     ...searchValues,
  //     ngayTaoTu: dayjs().subtract(1, "day").format("DD/MM/YYYY"),
  //     ngayTaoDen: dayjs().subtract(1, "day").format("DD/MM/YYYY"),
  //   };
  //   setSearchValues(data);
  //   fetchInpatient(page, limit, data);
  // };

  columns.map((item) => {
    if (item.dataIndex === "stt") {
      item.render = (v, r, i) => i + 1 + (page - 1) * limit;
    }
    if (item.dataIndex === "action") {
      item.render = (v, record, i) => {
        return (
          <ListActionButton
            deleteFunction={() => handleDelete(record)}
            editFunction={() => handleRow(record)}
          />
        );
      };
    }
    if (item.dataIndex === "idTrangThaiNoiTru") {
      item.render = (v, r, i) => {
        return trangThaiNoiTru.find((it) => it.id === v)?.giaTri || "";
      };
    }
  });
  // const handleFormValuesChange = (changedValues, allChangedValues) => {
  //   let data = {
  //     ...allChangedValues,
  //     ...changedValues,
  //     ngaySinh: parseDatetime(allChangedValues.ngaySinh, "DD/MM/YYYY"),
  //     ngayTaoTu: parseDatetime(allChangedValues.ngayTaoTu, "DD/MM/YYYY"),
  //     ngayTaoDen: parseDatetime(allChangedValues.ngayTaoDen, "DD/MM/YYYY"),
  //   };
  //   Object.entries(data).forEach(([key, value]) => {
  //     if (value === "" || value === undefined || value === null) {
  //       delete data[key];
  //     }
  //   });
  //   setSearchValues(data);
  // };

  // useMemo(() => {
  //   let data = {
  //     ...searchValues,
  //     idTrangThaiNoiTru: searchTrangThai,
  //   };
  //   today ? (data.ngayTaoTu = dayjs().format("DD/MM/YYYY")) : null;
  //   today ? (data.ngayTaoDen = dayjs().format("DD/MM/YYYY")) : null;
  //   yesterday
  //     ? (data.ngayTaoTu = dayjs().subtract(1, "day").format("DD/MM/YYYY"))
  //     : null;
  //   yesterday
  //     ? (data.ngayTaoDen = dayjs().subtract(1, "day").format("DD/MM/YYYY"))
  //     : null;
  //   setSearchValues(data);
  //   fetchInpatient(page, limit, data);
  // }, [searchTrangThai]);

  // const onFinish = async (values) => {
  //   fetchInpatient(page, limit, { ...searchValues });
  // };

  const handleRow = async (record) => {
    dispatch(setIdDDNT(record.id));
    dispatch(setIdPhieuKham(record.idPhieuKham));
    dispatch(setIDPK(record.idPhieuKham));
    dispatch(setActiveKey(residentialNurse.NURSING.COME_IN_HOSPITAL_INFO));
  };
  const onSelectRow = async (selectedRowKeys, selectedRows, info) => {
    dispatch(setIdDDNT(selectedRows[0].id));
    dispatch(setIdPhieuKham(selectedRows[0].idPhieuKham));
    dispatch(setIDPK(selectedRows[0].idPhieuKham));
  };
  useEffect(() => {
    dispatch(setButtonsHeader([]));
    fetchDanhMucNoiTru();
    fetchDanhMucTrangThaiNoiTru();
    // fetchInpatient(page, limit, searchValues);
  }, []);

  useEffect(() => {
    if (activeTab === residentialNurse.NURSING.LIST_PATIENT) {
      fetchInpatient();
    }
  }, [activeTab, params, page]);

  //Thang xl
  const formatParams = () => {
    return {
      ...params,
      ngaySinh: formatDateToString(params.ngaySinh),
      ngayTaoTu: formatDateToString(params.ngayTaoTu, FORMAT_TIME.dayFull),
      ngayTaoDen: formatDateToString(params.ngayTaoDen, FORMAT_TIME.dayFull),
    };
  };
  const onPaginationChange = (page, pageSize) => {
    setPage(page);
    setLimit(pageSize);
  };
  const label = [
    {
      key: 1,
      value: "Hôm nay",
      onclick: (e) => onToday(e),
    },
    {
      key: 2,
      value: "Hôm qua",
      onclick: (e) => onYesterday(e),
    },
  ];

  useEffect(() => {
    dispatch(setButtonsHeader([]));
  }, []);
  const onClickSearchButton = () => {
    const searchFields = expandRef.current?.getData();

    setParams({
      ...params,
      ...searchFields,
      page,
    });
    setPage(1);
  };

  const onToday = (key: number) => {
    setLoading(true);
    let today = dayjs();
    expandRef.current?.setFieldValue("ngayTaoTu", today);
    expandRef.current?.setFieldValue("ngayTaoDen", today);
    setParams({ ...params, ...expandRef.current?.getData() });
    setSelectedBtn(key);
  };

  const onYesterday = (key: number) => {
    setLoading(true);
    let yesterday = dayjs().subtract(1, "day");
    expandRef.current?.setFieldValue("ngayTaoTu", yesterday);
    expandRef.current?.setFieldValue("ngayTaoDen", yesterday);
    setParams({
      ...params,
      ...expandRef.current?.getData(),
    });

    setSelectedBtn(key);
  };
  const onKeyDown = async (e) => {
    if (e.key === "Enter") {
      //  setTimeout(() => {
      onClickSearchButton();
      // }, 500);
    }
  };
  return (
    <div className="">
      <div className="container" onKeyDown={onKeyDown}>
        <ExpandSearch
          ref={expandRef}
          onClickSearch={onClickSearchButton}
          fields={dataListPatientResidentialFields}
          onReset={onClickSearchButton}
          initialValues={params}
        ></ExpandSearch>
      </div>
      <div className="container">
        <Space direction="vertical" style={{ width: "100%" }}>
          <Row justify={"end"} gutter={[16, 16]}>
            <Space>
              {label.map((item) => (
                <Button
                  key={item.key}
                  onClick={() => {
                    item.onclick(item.key);
                  }}
                  className={
                    item.key === selectedBtn ? "btn-sub" : "custom-btn"
                  }
                  icon={
                    item.key === selectedBtn ? (
                      <CalendarSelectedSVG />
                    ) : (
                      <CalendarSVG />
                    )
                  }
                >
                  {item.value}
                </Button>
              ))}
              <Popover
                trigger="click"
                placement="topLeft"
                content={
                  <ColumnPopoverDisplay
                    setShowColumns={setShowAllColumns}
                    columns={defaultColumns}
                  ></ColumnPopoverDisplay>
                }
              >
                <Button className="btn-sub" icon={<ListIconSVG />}>
                  Cột hiển thị
                </Button>
              </Popover>
            </Space>
          </Row>
          <CustomResizableTable
            setShowColumns={setShowAllColumns}
            rowKey={(record) => record.id}
            bordered
            dataSource={inpatients.data}
            // scroll={{y: 500}}
            // className="custom-resize-table-scroll"
            loading={loading}
            // setShowColumns={setShowColumns}
            pagination={{
              total: inpatients.total,
              pageSize: params.limit,
              current: page,
              onChange: onPaginationChange,
              showSizeChanger: true,
            }}
            onRow={(record) => ({
              onDoubleClick: () => handleRow(record),
            })}
            columns={columns}
            rowSelection={{
              type: "radio",
              onChange: onSelectRow,
            }}
          />
        </Space>
      </div>
    </div>
  );
};

export default ListPatient;
